import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Avatar, RoleChip, Badge, Panel, PageHead, EmptyState } from "@/sentinel";

const ROLES = ["viewer", "analyst", "owner"];

export default function Members() {
  const { data: rows = [] } = useQuery({ queryKey: ["pm-members"], queryFn: api.pmMembers });
  return (
    <div className="sn-stack" style={{ gap: "var(--space-5)" }} data-testid="pm-members">
      <PageHead crumb={["Project", "Members"]} title="Members" context={<>People with access to the workspace (<span className="sn-num">{rows.length}</span>).</>} />
      <Panel title="Workspace members" icon="Users" flush meta={<span className="sn-num">{rows.length}</span>}>
        {rows.length === 0 ? (
          <div style={{ padding: "var(--space-4)" }}><EmptyState icon="Users" title="No members yet" /></div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table className="sn-table">
              <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Provider</th><th>Status</th></tr></thead>
              <tbody>
                {rows.map((m) => (
                  <tr key={m.external_id}>
                    <td style={{ color: "var(--text-primary)" }}>
                      <span className="sn-row" style={{ gap: "var(--space-2)", flexWrap: "nowrap" }}><Avatar name={m.name || m.email} size="sm" />{m.name}</span>
                    </td>
                    <td className="sn-small">{m.email}</td>
                    <td>{ROLES.includes(m.role) ? <RoleChip role={m.role} /> : <Badge>{m.role}</Badge>}</td>
                    <td>{m.auth_provider}</td>
                    <td><Badge icon={String(m.status).toLowerCase() === "active" ? "Check" : "Circle"}>{m.status}</Badge></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
